<template>
    <div>
        <v-card elevation="0" v-if="tableloading" height="300px" width="100%">
            <v-row justify="center" align="center" class="fill-height">
                <v-col cols="6">
                    <v-progress-linear
                        indeterminate
                        rounded
                        height="6"
                        color="#B2C6C2"
                    ></v-progress-linear>
                </v-col>
            </v-row>
        </v-card>
        <v-card elevation="0" color="#B2C6C2" v-else>
            <v-card-subtitle style="color:white;">
                <v-icon color="white" small>mdi-information-outline</v-icon>&nbsp;Note: Applicants cannot see stopped or expired postings.<br />
                <v-icon color="white" small>mdi-link-variant</v-icon>&nbsp;Links for the postings point to /jobpostings, where the active postings can be seen without sign-in process.
            </v-card-subtitle>
            <v-data-iterator
                :items="items" :page.sync="page" :search="search" :sort-by="sortBy" :sort-desc="sortDesc" :items-per-page="12" :custom-filter="customSearchFilter"
            >
                <template v-slot:header>
                    <v-toolbar dark color="#004236" class="mb-1">
                        <v-text-field v-model="search" clearable flat solo-inverted prepend-inner-icon="mdi-magnify" label="Search" dense hide-details></v-text-field>&nbsp;
                        <span class="text-caption white--text">Search will only search for 'Discipline' (NOT Title) or/and 'Catalog(s)' fields</span>
                        <v-spacer></v-spacer>
                        <v-btn fab x-small color="#D1E2C4" @click="dialogForm = true"><v-icon color="#004236">mdi-application-edit-outline</v-icon></v-btn>
                    </v-toolbar>
                </template>
                <template v-slot:default="props">
                    <v-row class="pa-1 ma-1">
                        <v-col
                            v-for="item in props.items"
                            :key="item.classnbr"
                            cols="12"
                            sm="12"
                            md="6"
                            lg="4"
                        >
                            <v-card width="550px">
                                <v-toolbar elevation="0">
                                    <v-toolbar-title>{{ item["title"] }}</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-btn icon color="#DF362D" v-if="/stop/i.test(item.status)">
                                        <v-icon>mdi-alert-octagon-outline</v-icon>
                                    </v-btn>
                                    <v-btn icon color="#05445E" @click="viewLink(item.link)" v-if="item.status == 'active' && !calEndDate(item.endDate)"><v-icon>mdi-link-variant</v-icon></v-btn>
                                    <v-btn icon color="#FDB750" v-if="item.status == 'active' && calEndDate(item.endDate)"><v-icon>mdi-clock-alert-outline</v-icon></v-btn>
                                </v-toolbar>
                                <v-list dense height="350px">
                                    <v-list-item
                                        v-for="(key, index) in filteredKeys"
                                        :key="index"
                                    >
                                        <v-row>
                                            <v-col cols="12" sm="4">
                                                <v-list-item-content :class="{ 'green--text': sortBy === key.value }">
                                                    {{ key.text }}:
                                                </v-list-item-content>
                                            </v-col>
                                            <v-col cols="12" sm="8">
                                                <v-list-item-content
                                                    class="align-end"
                                                    :class="{ 'green--text': sortBy === key.text }"
                                                >
                                                    {{ item[key.value] }}
                                                </v-list-item-content>
                                            </v-col>
                                        </v-row>
                                    </v-list-item>
                                </v-list>
                                <v-card-actions>
                                    <v-btn color="#6d6e71" @click="viewPostingPrint(item)" outlined block>Print Posting</v-btn>
                                </v-card-actions>
                                <v-card-actions>
                                    <v-btn color="#d7ae28" @click="viewPosting(item)" block>View Posting</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-row>
                </template>
                <template v-slot:no-data>
                    <v-container style="height: 400px;">
                        <v-row
                            class="fill-height"
                            align-content="center"
                            justify="center"
                        >
                            <v-col
                                class="text-subtitle-1 text-center"
                                cols="12"
                            >
                                No available Postings
                            </v-col>
                        </v-row>
                    </v-container>
                </template>
            </v-data-iterator>
            <v-dialog
                v-model="dialogview"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-toolbar
                        dark
                        color="#004236"
                    >
                        <v-toolbar-title>{{ selectedPosting["subject-resolved"] }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn
                                icon
                                dark
                                @click="dialogview = false"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <ViewPosting v-if="dialogview" :item="selectedPosting" />
                </v-card>
            </v-dialog>
            <v-dialog
                v-model="dialogPrintView"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-toolbar
                        dark
                        color="#004236"
                    >
                        <v-toolbar-title>Print View for {{ selectedPostingPrint["subject-resolved"] }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn
                                icon
                                dark
                                @click="dialogPrintView = false"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <ViewPrintPosting v-if="dialogPrintView" :item="selectedPostingPrint" />
                </v-card>
            </v-dialog>
            <v-dialog
                v-model="dialogForm"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-toolbar
                        dark
                        color="#004236"
                    >
                        <v-toolbar-title>Application Form View</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn
                                icon
                                dark
                                @click="dialogForm = false"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-card elevation="0">
                        <v-card-text>
                            <v-alert border="top" colored-border type="info" elevation="2">
                                This is a sample application form view using the first posting of the list. Your submission will not be saved as an application.
                            </v-alert>
                            <v-divider></v-divider>
                            <ApplicationForm :posting="[items[0]]" />
                        </v-card-text>
                    </v-card>
                </v-card>
            </v-dialog>
            <!-- <v-dialog v-model="dialogLink" width="750" hide-overlay>
                <v-card outlined>
                    <v-card-text><br />
                        <v-text-field outlined dense readonly v-model="selectedItemLink" hide-details>
                            <template v-slot:append-outer>
                                <v-btn icon small color="#05445E" @click="copyLink"><v-icon>mdi-content-copy</v-icon></v-btn>
                                <v-btn icon small color="#EF6C00" @click="dialogLink = false"><v-icon>mdi-close-circle-outline</v-icon></v-btn>
                            </template>
                        </v-text-field>
                    </v-card-text>
                </v-card>
            </v-dialog> -->
        </v-card>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
import ViewPosting from "./ViewPosting.vue"
import ViewPrintPosting from "./ViewPostingPrint.vue"
import ApplicationForm from "../../Applicants/BrowsePostings/ApplicationForm.vue"

export default {
    components: {
        ViewPosting,
        ViewPrintPosting,
        ApplicationForm
    },
    data () {
      return {
        host: location.hostname.toString(),
        tableloading: false,
        search: '',
        filter: {},
        sortDesc: true,
        page: 1,
        sortBy: 'postingstarttimestamp',
        keys: [
            {"text": "Term", "value": "term"},
            {"text": "Discipline", "value": "discipline"},
            {"text": "Type", "value": "type"},
            {"text": "Course(s)", "value": "coursesText"},
            {"text": "Section(s)", "value": "sectionsText"},
            {"text": "Format", "value": "classformat"},
            {"text": "Posted at", "value": "startDate"},
            {"text": "Apply by", "value": "endDate"}
        ],
        items: [],
        dialogview: false,
        dialogadd: false,
        dialogForm: false,
        selectedPosting: {},
        selectedPostingPrint: {},
        selectedItemLink: "",
        dialogPrintView: false,
        dialogLink: false,
        snackbar: false,
        snackbarcolor: "",
        text: "",
        timeout: 3500,
      }
    },
    computed: {
        filteredKeys () {
            return this.keys
        },
    },
    methods: {
        sortDatabyDiscipline(){
            const that = this;
            if(that.sortBy == "subject-resolved"){
                that.sortDesc = false;
            }else {
                that.sortDesc = true;
            }
        },
        customSearchFilter(items, search){
            if(search == "" || search == null){
                return items
            }else {
                let loweredsearch = search.toLowerCase();
                
                let spacestripedout = loweredsearch.replace(" ", "");
                
                return items.filter(v=> v.discipline.toLowerCase().includes(loweredsearch) ||  v.coursesText.toLowerCase().includes(loweredsearch) || (v.discipline.toLowerCase()+v.coursesText.toLowerCase()).includes(spacestripedout))
            }
        },
        loadPostings(){
            const that = this;

            that.tableloading = true;
            let api = 'https://'+that.host+'/cgi-bin/cupe-app-api/api.py?mode=adminpostingssearch&data={"approvals":{"$size":2}}';

            //API calling
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/^OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#EF6C00"); //orange
                    }else {
                        that.items = resultData.data;

                        that.modifyData();
                        that.tableloading = false;
                    }
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
            //End of API calling
        },
        modifyData(){
            const that = this;

            that.items.forEach(element => {   
                //Courses
                var courselist = "";
                var sections = "";
                var format = "";
                element["courses"].forEach(e => {
                    if(e["ssrcomponent"] == "LEC"){
                        courselist += e["catalognbr"]+", ";
                        sections += e["classsection"]+", ";
                        format += e["classformat"]+", ";
                    }
                });

                element["term"] = that.resolveTerm(element["strm"]);
                element["coursesText"] = courselist.slice(0,-2);
                element["sectionsText"] = sections.slice(0,-2);
                element["subject-resolved"] = element["courses"][0]["subject-resolved"]+"("+element["discipline"]+")";
                element["postingstarttimestamp"] = Date.parse(element["startDate"]);
                element["classformat"] = format.slice(0,-2);

                element["link"] = "https://"+that.host+"/cupe-app/app/#/jobpostings/"+element["id"];
            });
        },
        resolveTerm(stream){
            const that = this;
            let term = stream.slice(-1);
            var year = stream[1]+stream[2];
            var year2 = (parseInt(year)+1).toString();
            var century = (parseInt(stream[0])-1).toString();
            if(term == "9"){
                return "FALL 2"+century+year+"/WINTER 2"+century+year2;
            }else if(term == "5"){
                return "SUMMER 2"+century+year;
            }
        },
        calEndDate(date){
            const MSPERDAY = 1000 * 60 * 60 * 24;
            let today = new Date();
            let due = new Date(date);
            let todayutc = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
            let dateutc = Date.UTC(due.getFullYear(), due.getMonth(), due.getDate());

            let daysleft = Math.floor((dateutc - todayutc) / MSPERDAY)+1;

            if(daysleft < 0){
                return true
            }else {
                return false
            }
        },
        viewPosting(item){
            const that = this;

            that.selectedPosting = item;
            that.dialogview = true;
        },
        viewPostingPrint(item){
            const that = this;

            that.selectedPostingPrint = item;
            that.dialogPrintView = true;
        },
        viewLink(itemLink){
            const that = this;

            navigator.clipboard.writeText(itemLink);

            that.dialogLink = false;
            that.setSnackbar("Link copied to clipboard", "#05445E"); //orange
        },
        // viewLink(itemLink){
        //     const that = this;
        //     that.selectedItemLink = itemLink;
        //     that.dialogLink = true;
        // },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        },
        // copyLink(){
        //     const that = this;
        //     navigator.clipboard.writeText(that.selectedItemLink);

        //     that.dialogLink = false;
        //     that.setSnackbar("Link copied to clipboard", "#05445E"); //orange
        // }
    },
    created(){
        const that = this;
        that.loadPostings();
    }
}
</script>